import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../../backend/firebaseConfig";

export const MAX_PASSPORT_IMAGES = 3;
export function getPassportEntries(adviserDoc = {}) {
  if (Array.isArray(adviserDoc.passports)) return adviserDoc.passports;
  const legacy = adviserDoc.passportDetails;
  return legacy && (legacy.expiryDate || legacy.images?.length)
    ? [{...legacy, id: "legacy-passport", holderName: legacy.holderName || "", relationship: legacy.relationship || "Adviser"}]
    : [];
}
export function getEditablePassportEntries(adviserDoc = {}, personal = {}) {
  const entries = getPassportEntries(adviserDoc);
  const selfIndex = entries.findIndex(entry => entry.isSelf || entry.id === "self-passport" ||
    entry.id === "legacy-passport" || /^(self|adviser)$/i.test(entry.relationship || ""));
  const name = [personal.preferredName || personal.forename || personal.firstName || adviserDoc.firstName,
    personal.surname || personal.lastName || adviserDoc.lastName].filter(Boolean).join(" ");
  const self = selfIndex >= 0 ? entries[selfIndex] : {id: "self-passport", holderName: name, expiryDate: "", images: []};
  return [{...self, holderName: self.holderName || name, isSelf: true, relationship: "Self"}, ...entries.filter((_, index) => index !== selfIndex)];
}
export function validatePassportImages(saved = [], pending = []) {
  if (saved.length + pending.length > MAX_PASSPORT_IMAGES) throw new Error("A maximum of three passport attachments is allowed. Remove an attachment before adding another.");
  for (const file of pending) {
    if (!["image/jpeg", "image/png", "image/webp", "application/pdf"].includes(file.type)) throw new Error("Passport attachments must be JPG, PNG, WebP or PDF files.");
    if (file.size > 10 * 1024 * 1024) throw new Error("Each passport attachment must be 10 MB or smaller.");
  }
}
export async function uploadPassportImages(adviserId, files = []) {
  const uploaded = [];
  for (const file of files) {
    const path = `Advisers/${adviserId}/Passport/${crypto.randomUUID()}`;
    const target = ref(storage, path);
    await uploadBytes(target, file, {contentType: file.type});
    uploaded.push({name: file.name, url: await getDownloadURL(target), storagePath: path});
  }
  return uploaded;
}

export async function deletePassportImages(adviserId, images = []) {
  for (const image of images) {
    const path = image.storagePath;
    if (!path || !path.startsWith(`Advisers/${adviserId}/Passport/`)) continue;
    try { await deleteObject(ref(storage, path)); }
    catch (error) { if (error.code !== "storage/object-not-found") throw error; }
  }
}
